import type { CartOverview } from '@/domains/shoppingCart/services/msfCart/interfaces/common';

export const sumCartOverviewQuantities = (overview?: CartOverview) => {
  if (!overview) return 0;
  return Object.values(overview).reduce((a, b) => a + b, 0);
};
